import React from 'react';
import { ApplicationIcon, Box } from '@saviynt/design-system';
import cx from 'classnames';

import { CF_SAV_MED } from '../../../../shared/constants';

interface ResponseWrapperProps {
  id: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * ResponseWrapper
 */
function ResponseWrapper({ id, children, className }: ResponseWrapperProps) {
  return (
    <div data-scroll-id={id} className={cx('ResponseWrapper', className)}>
      <Box tag='div' className='ResponseWrapper-avatar'>
        <ApplicationIcon
          icon='SaviCompanionGradient'
          iconColor={CF_SAV_MED}
          size='small'
        />
      </Box>
      <Box tag='div' className='ResponseWrapper-content'>
        {children}
      </Box>
    </div>
  );
}

ResponseWrapper.defaultProps = {
  className: null,
};

export default ResponseWrapper;
